import BorderGradient from 'components/shared/BorderGradient/BorderGradient';
import { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

interface Invoice {
  id: string;
  invoiceNumber: string;
  customerName: string;
  subscriptionType: string;
  inoviceDate: string;
  amount: string;
  dueDate: string;
  paymentStatus: string;
  paymentMethod: string;
}

interface InvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  initialData?: Invoice | null;
  setRefreshMode: (value: string) => void;
}
interface InvoiceItem {
  id: string;
  description: string;
  quantity: number;
  unitPrice: number;
  total: number;
}

export default function InvoiceModal({
  isOpen,
  onClose,
  mode,
  initialData,
  setRefreshMode
}: InvoiceModalProps) {
  const [formData, setFormData] = useState<Omit<Invoice, 'id'>>({
    invoiceNumber: '',
    customerName: '',
    subscriptionType: '',
    inoviceDate: '',
    amount: '',
    dueDate: '',
    paymentStatus: '',
    paymentMethod: ''
  });

  const [invoiceItems, setInvoiceItems] = useState<InvoiceItem[]>([]);

  useEffect(() => {
    if (initialData && mode === 'edit') {
      const { id, ...rest } = initialData;
      setFormData(rest);
    }
  }, [initialData, mode]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // TODO: Implement API call
      setRefreshMode('invoices');
      onClose();
    } catch (error) {
      console.error('Error submitting invoice:', error);
    }
  };

  const handleAddInoviceItem = () => {
    const newItem = {
      id: new Date().getTime().toString() + Math.random().toString(36).substring(2, 15),
      description: '',
      quantity: 0,
      unitPrice: 0,
      total: 0
    };
    setInvoiceItems((prev) => ([...prev,newItem ]));
  };

  const handleItemChange = (id: string, field: string, value: any) => {
    setInvoiceItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, [field]: value, total: field === 'quantity' || field === 'unitPrice' ? item.quantity * item.unitPrice : item.total }
          : item
      )
    );
  };
  
  const handleRemoveItem = (id: string) => {
    setInvoiceItems((prev) => prev.filter((item) => item.id !== id));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <BorderGradient className='w-full max-w-2xl '>
      <div className="bg-[#1A1A1A] rounded-lg w-full max-w-2xl overflow-y-auto" style={{ maxHeight: 'calc(90vh - 100px)' }}>
        <div className="flex items-center justify-between p-4 border-b border-white/[0.08]">
          <h2 className="text-xl font-semibold text-white">
            {mode === 'add' ? 'Add Invoice' : 'Edit Invoice'}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-[#2A2A2A] rounded-full"
          >
            <FiX className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        <div className=" p-4">
          <h2 className="text-base font-semibold text-white">
            Customer Details
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="grid grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Customer Name
                </label>
                <input
                  type="text"
                  value={formData.customerName}
                  onChange={(e) => setFormData({ ...formData, customerName: e.target.value })}
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Email
                </label>
                <input
                  type="text"
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-4">

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Invoice Date
                </label>
                <input
                  type="date"
                  value={formData.inoviceDate}
                  onChange={(e) => setFormData({ ...formData, inoviceDate: e.target.value })}
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Billing address
                </label>

                <input
                  type="text"
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
                {/* <select
                  value={formData.billingAddress}
                  onChange={(e) => setFormData({ ...formData, billingAddress: e.target.value })}
                  className="w-full bg-[#1A1A1A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                >
                  <option value="">Select Type</option>
                  <option value="Basic">Basic</option>
                  <option value="Premium">Premium</option>
                  <option value="Enterprise">Enterprise</option>
                </select> */}
              </div>

            </div>
          </div>






          <div className="flex justify-between items-center py-4">
          <div className="">
            <h2 className="text-base font-semibold text-white">
              Invoice Items
            </h2>
          </div>
            <button
              onClick={handleAddInoviceItem}
              className="flex items-center gap-2 bg-[#2A2A2A] shadow-md rounded-md px-4 py-2 text-white"
          >
              + Add Item
            </button>
          </div>

          <table className="w-full bg-[#2A2A2A] rounded-lg px-3 py-2 text-white">
  <thead>
    <tr className="text-left p-2">
      <th>Description</th>
      <th>Quantity</th>
      <th>Unit Price</th>
      <th>Total</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {invoiceItems.map((item) => (
      <tr key={item.id}>
        <td>
          <input
            type="text"
            value={item.description}
            onChange={(e) => handleItemChange(item.id, 'description', e.target.value)}
            className="bg-transparent border border-gray-500 px-2 py-1 rounded-md text-white"
          />
        </td>
        <td>
          <input
            type="number"
            value={item.quantity}
            onChange={(e) => handleItemChange(item.id, 'quantity', parseInt(e.target.value) || 0)}
            className="bg-transparent border border-gray-500 px-2 py-1 rounded-md text-white w-16"
          />
        </td>
        <td>
          <input
            type="number"
            value={item.unitPrice}
            onChange={(e) => handleItemChange(item.id, 'unitPrice', parseFloat(e.target.value) || 0)}
            className="bg-transparent border border-gray-500 px-2 py-1 rounded-md text-white w-16"
          />
        </td>
        <td>{(item.quantity * item.unitPrice).toFixed(2)}</td>
        <td>
          <button onClick={() => handleRemoveItem(item.id)} className="text-red-500 hover:text-red-700">✖</button>
        </td>
      </tr>
    ))}
  </tbody>
</table>


          <div className="py-4">
            <h2 className="text-base font-semibold text-white">
              Other details
            </h2>
          </div>




          <div className="grid grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-4">

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Tax
                </label>
                <input
                  type="text"
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Notes
                </label>
                <input
                  type="text"
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-4">

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Discounts
                </label>
                <input
                  type="tel"
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-400 mb-1">
                  Total Amount
                </label>

                <input
                  type="text"
                  className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white"
                  required
                />

              </div>

            </div>

          </div>

          <div className="flex justify-end mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-400 hover:text-white"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="ml-4 bg-[#2A2A2A] hover:bg-[#3a3a3a33]  px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
            >
              {mode === 'add' ? 'Add Invoice' : 'Update Invoice'}
            </button>
          </div>

        </form>
      </div>
      </BorderGradient>
    </div>
  );
} 